import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { PleaseBePatientComponent } from '../../../../components/please-be-patient/please-be-patient.component';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrl: './imprint.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    PleaseBePatientComponent,
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
  ],
})
export class ImprintComponent
  extends BaseModalComponent<{ displayName: string; imprint: string }, {}>
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  ngOnInit(): void {
    this.form.setValue({
      displayName: this.displayName,
      imprint: this.imprint?.includes('imprint.md') ? '' : this.imprint,
    });
  }

  displayName: string;
  imprint: string;

  form = new SubmittableForm({
    displayName: new FormControl('', [Validators.required]),
    imprint: new FormControl(''),
  });

  abort() {
    this.close();
  }

  get formNotTouched() {
    return this.form.pristine;
  }

  submit() {
    this.result = this.form.value;
    this.close();
  }
}
